var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ClrDatagridSortOrder } from '@clr/angular';
import { ApiRoutePlurality, BACKUP_FIELD, HTTP_METHOD, RIGHTS } from '../../../../defs/schema-static';
import { CLIENT_SCHEMA_ROUTE } from '../../../../defs/schema/public/Clients';
import { PROJECT_SCHEMA_ROUTE } from '../../../../defs/schema/public/Projects';
import { DATAGRID_FILTER_TYPE } from '../app-static';
import { FileDownloaderService } from '../shared/file-downloader/file-downloader.service';
import { HttpRestService } from '../shared/http-rest/http-rest.service';
var BackupsListComponent = (function () {
    function BackupsListComponent(httpRest, fileDownloader) {
        this.httpRest = httpRest;
        this.fileDownloader = fileDownloader;
        this.prefix = '';
        this.RIGHTS = RIGHTS;
        this.DATAGRID_FILTER_TYPE = DATAGRID_FILTER_TYPE;
        this.BACKUP_COLUMNS = [
            { field: BACKUP_FIELD.key, translateKey: 'table_key' },
            {
                field: BACKUP_FIELD.date,
                translateKey: 'date',
                order: ClrDatagridSortOrder.DESC,
                filterType: DATAGRID_FILTER_TYPE.DATE,
            },
            { field: BACKUP_FIELD.size, translateKey: 'filesize' },
        ];
        this.filterOpen = {};
    }
    BackupsListComponent.prototype.ngOnInit = function () {
        this.getBackups();
    };
    BackupsListComponent.prototype.ngOnChanges = function (changes) {
        if (changes.project || changes.client) {
            this.backups = undefined;
            this.getBackups();
        }
    };
    BackupsListComponent.prototype.getBackups = function () {
        var _this = this;
        if ((!this.project || !this.project.id) && (!this.client || !this.client.id)) {
            return;
        }
        var route = !!this.project ? PROJECT_SCHEMA_ROUTE : CLIENT_SCHEMA_ROUTE;
        var id = (!!this.project && this.project.id) || (!!this.client && this.client.id);
        this.httpRest
            ._request(HTTP_METHOD.GET, ApiRoutePlurality.SINGULAR, route, "backup/" + id)
            .subscribe(function (res) {
            var backups = res.backups, prefix = res.prefix;
            _this.backups = backups.slice();
            _this.prefix = prefix;
        });
    };
    BackupsListComponent.prototype.downloadBackup = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var route;
            return __generator(this, function (_a) {
                route = !!this.project ? PROJECT_SCHEMA_ROUTE.singularRoute : CLIENT_SCHEMA_ROUTE.singularRoute;
                return [2, this.fileDownloader.downloadAPI([route, 'backup/file', file].join('/'))];
            });
        });
    };
    BackupsListComponent.prototype.getKeyWithoutPrefix = function (backup) {
        if (!this.prefix) {
            return backup.key;
        }
        return backup.key.replace(new RegExp("^" + this.prefix), '');
    };
    return BackupsListComponent;
}());
export { BackupsListComponent };
